import { schoolMissionBannerAr, schoolMissionBannerEn } from "assets/images";
import { SchoolSection } from "../components/SchoolSection";
import { SectionTitle } from "../components/SectionTitle";
import { useSchoolLocal } from "../useSchoolLocal";

export const SchoolMission = () => {
  const { t, isArabic } = useSchoolLocal();

  return (
    <SchoolSection className="bg-[#F8F8F8]" contentClassName="py-14 md:py-20">
      <div className="max-w-[760px]">
        <SectionTitle className="mb-5">{t("mission.title")}</SectionTitle>
        <blockquote className="mb-5 text-lg font-medium leading-relaxed md:text-[22px]">
          {t("mission.quote")}
        </blockquote>
        <p className="text-sm text-[#828282]">
          <strong className="text-[#2E2E38]">{t("mission.founderName")}</strong>
          {" · "}
          {t("mission.founderRole")}
        </p>
      </div>
      {/* Wide banner with its own headline, so it gets the full width. */}
      <img
        src={isArabic ? schoolMissionBannerAr : schoolMissionBannerEn}
        alt={t("mission.imageAlt")}
        className="mt-10 w-full rounded-2xl"
      />
    </SchoolSection>
  );
};
